import React from "react";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import "./Chat.scss";
import { formatTime } from "../../../helpers/utilities";
import { getUserDisplayName } from "../../../helpers/userDisplayName";
const Chat = ({ chat, className, handleClick }) => {

    const { chat_with, read, messages } = chat

    const lastMessage = messages[messages.length - 1]

    return (
        <div className={`conversation-item ${className}`} onClick={() => handleClick(chat)}>
            <ProfilePicture imgUrl={chat?.chat_with?.profilePicture} width={58} height={58} no_edit={true} />
            <div className="conversation-info">
                <p className={`conversation-name ${read ? 'conversation-name-read' : 'conversation-name-unread'}`}>
                    {getUserDisplayName(chat_with)}
                </p>
                <div className="conversation-details">
                    <span className={`conversation-message ${read ? 'conversation-message-read' : 'conversation-message-unread'}`}>
                        {lastMessage?.text || 'No messages yet'}
                    </span>
                    <span className="conversation-separator"></span>
                    <span className="conversation-timestamp">{formatTime(lastMessage?.created_at || chat.created_at)}</span>
                </div>
            </div>
            {!read && <div className="conversation-unread-indicator"></div>}
        </div>)
};

export default Chat;    